var _defs, _path, _g, _rect, _path2, _g2, _path3, _g3, _g4, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _g5, _path11, _path12, _path13, _g6, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1873",
    "data-name": "Group 1873",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 544.974,
    height: 357.994,
    viewBox: "0 0 544.974 357.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2105",
    x: 367.708,
    y: 102.649,
    width: 102.188,
    height: 112.416,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2102",
    x: 310.93,
    y: 120.096,
    width: 153.801,
    height: 191.63,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M480.568,354.519l.015,5.813v1.228H469.358v-1.843l-.007-22.733-.015-22.024v-4.044l-.007-16.394-.007-.263-1.952-55.2v-.044l-1.989-56.267v-.007l-.051-1.528-9.689,5.14-11.948,6.34-5.674,3.013-8.1,4.292-13.659,7.254h-.007l-70.84,37.577-.146,115.5v1.228H334.427l-.044-1.228-3.6-111.115L226.31,207.559l-11.056-4.409-4.724-65.2a40.3,40.3,0,0,1,32.554-42.52l15.955-3.093,39.822-7.729,12.884-2.493,16.84-3.269,6.639-1.287,10.917-2.121.987-.19,3.078-.6,1.1-.212,1.784-.344,1.258,2.223c.007,0,.007.007.007.015l7.4,13.133,1.331,2.369.007.007,6.413,11.37a.025.025,0,0,1,.007.015l6.244,11.085,12.255,2.435,6.04,1.2,37.438,7.436,4.936.987h.007l12.489,2.479,3.305.658,15.436,3.064.117.022,6.852,1.36,11.539,2.3L480.4,294.523l.11,38.586v.007l.059,21.4Z",
    transform: "translate(-13.738 -4.837)",
    fill: "#cfd8dc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1869",
    "data-name": "Group 1869",
    transform: "translate(237.357 14.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M291.86,45.66c-1.638-3.086-6.347-9.689-11.772-17.1-1.009-1.382-2.04-2.786-3.078-4.2-1.85-2.508-3.729-5.06-5.55-7.546a3.65,3.65,0,0,0-5.075-.87l-10.91,7.722a3.634,3.634,0,0,0-.87,5.067l3.283,4.643.863,1.221,1.272,1.8,1.528,2.157v.007l.431.6,1.521,2.157.841,1.185,7.363,10.412,3.305,4.672a3.64,3.64,0,0,0,5.067.87l9.491-6.72,1.338-.943.08-.059a3.634,3.634,0,0,0,.87-5.067Z",
    transform: "translate(-253.937 -15.271)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M281.68,29.028l-2.844-4.014a.147.147,0,0,0-.212-.037l-.007.007a.141.141,0,0,0-.029.2l2.844,4.022a.158.158,0,0,0,.212.037.2.2,0,0,0,.051-.059.16.16,0,0,0-.015-.161Z",
    transform: "translate(-255.544 -15.903)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M271.2,17.029,291.6,45.884c1.008,1.425.489,3.045-.849,4.127l-1.1.834c-.02.016-9.3,6.88-10.925,7.565s-3.416-1.008-3.416-1.008L254.91,28.548a3.29,3.29,0,0,1,.787-4.587l1.6-1.134a.6.6,0,0,1,.806.113c.014.016.028.031.043.046a.668.668,0,0,0,.852.052l5.638-3.987a.668.668,0,0,0,.235-.82c-.009-.019-.019-.037-.029-.056a.6.6,0,0,1,.162-.8l1.6-1.134a3.29,3.29,0,0,1,4.587.787Z",
    transform: "translate(-253.961 -15.295)",
    fill: "#1d89d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M259.01,35.707l-.717-1.009a.145.145,0,0,0-.139-.066.156.156,0,0,0-.11.241l.709,1.009a.161.161,0,0,0,.219.037.107.107,0,0,0,.044-.066.149.149,0,0,0-.007-.146Z",
    transform: "translate(-254.203 -16.535)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M261.952,39.874l-1.375-1.952a.153.153,0,0,0-.139-.058.109.109,0,0,0-.073.022.154.154,0,0,0-.037.219L261.7,40.05a.153.153,0,0,0,.212.037.2.2,0,0,0,.051-.059V40.02a.134.134,0,0,0-.015-.146Z",
    transform: "translate(-254.352 -16.746)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M264.041,42.831l-1.375-1.952a.17.17,0,0,0-.212-.037.154.154,0,0,0-.037.219l1.375,1.945a.153.153,0,0,0,.212.037.117.117,0,0,0,.051-.066.135.135,0,0,0-.015-.146Z",
    transform: "translate(-254.488 -16.939)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1907",
    "data-name": "Rectangle 1907",
    width: 3,
    height: 0.385,
    rx: 0.192,
    transform: "matrix(0.816, -0.577, 0.577, 0.816, 1.183, 9.719)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_538",
    "data-name": "Ellipse 538",
    cx: 0.308,
    cy: 0.308,
    r: 0.308,
    transform: "translate(11.492 1.996)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    cx: 0.308,
    cy: 0.308,
    r: 0.308,
    transform: "translate(12.183 1.508)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 0.308,
    cy: 0.308,
    r: 0.308,
    transform: "translate(12.873 1.019)",
    fill: "#e6e6e6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1908",
    "data-name": "Rectangle 1908",
    width: 42.41,
    height: 40.217,
    transform: "translate(289.993 33.79)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M276.358,49.2a14.494,14.494,0,0,1-4.8,4.882L260.2,75.442l-10.006-5.7,12.6-21.054A14.493,14.493,0,0,1,265,42.2c3.036-4.931,8.041-7.361,11.178-5.429s3.22,7.5.184,12.426h0Z",
    transform: "translate(-16.335 -2.358)",
    fill: "#a0616a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    "data-name": "Group 1870",
    transform: "translate(444.38 288.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M483.876,352.886,493,351.058l-4.115-41.9-13.462,2.7Z",
    transform: "translate(-475.42 -309.154)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M519.31,366.249h0a2.685,2.685,0,0,1-1.805,3.322l-18.011,4.053a16.673,16.673,0,0,0-11.292-8.166l1.795,10.3-9.291,2.091-2.562-16.64s-4.458-8.208-.3-13.85.113-4.078.113-4.078l-.252-10.6,14.412-1.508,3.686,15.9,10.369,14.269,11.1,2.688a2.882,2.882,0,0,1,2.039,2.218h0Z",
    transform: "translate(-475.463 -310.592)",
    fill: "#2f2e41"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M316.116,125.738l.731,5.118s15.355,16.818,19.012,24.13l44.354-21.936-7.793-18.28-56.3,10.968Z",
    transform: "translate(-20.639 -7.493)",
    fill: "#a0616a"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871",
    transform: "translate(398.667 186.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M441.826,239.415l8.85,2.868,16.909-38.561-13.061-4.234Z",
    transform: "translate(-427.514 -199.488)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M465.861,268.387h0a2.686,2.686,0,0,1-3.2,2.015l-17.692-5.276a16.673,16.673,0,0,0-5.854-12.646l-3.475,9.864-9.126-2.722,5.905-15.766s.127-9.339,6.509-12.229,2.093-3.5,2.093-3.5l4.965-9.367,13.307,5.734-4.562,15.668,2.064,17.518,8.37,7.777a2.883,2.883,0,0,1,.693,2.932h0Z",
    transform: "translate(-426.514 -200.747)",
    fill: "#2f2e41"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_2105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2105-2",
    "data-name": "Path 2105",
    d: "M403.021,155.083l16.021-6.581,37.292-24.13s28.517-22.812,30.711,7.971-18.28,78.312-18.28,78.312l-26.324-7.312,2.675-32.585-34.482,10.283Z",
    transform: "translate(-26.31 -7.59)",
    fill: "#e6e6e6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M359.8,70.839l20.224,54.591,27.42,30.345L434.5,138.226l-31.261-8.043.829-18.28Z",
    transform: "translate(-23.491 -4.625)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M231.714,365.925v1.57H220.825l-.028-1.57L217.03,165h14.1l.028,5.636Z",
    transform: "translate(-14.17 -10.773)",
    fill: "#cfd8dc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M473.242,144.805a14.493,14.493,0,0,1-5.315-4.311l-22.343-9.281,4.727-10.5,22.156,10.545a14.493,14.493,0,0,1,6.661,1.574c5.2,2.554,8.092,7.305,6.467,10.612s-7.155,3.917-12.352,1.364h0Z",
    transform: "translate(-29.092 -7.881)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M348.972,67.676l5.167-2.243s20.425,5.818,22.253,9.149,12.065,17.224,12.065,17.224l72.39,30.711-6.581,13.162-51.185-13.162L375.3,93.269Z",
    transform: "translate(-22.784 -4.272)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M337.813,63.037l-24.13-1.462-12.431,6.581,13.893,61.422s40.913-17.549,58.845-12.065c0,0,6.486-16.8-4.975-26.5L350.244,65.962l-12.431-2.925Z",
    transform: "translate(-19.669 -4.02)",
    fill: "#f7ca0b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_541",
    "data-name": "Ellipse 541",
    cx: 20.678,
    cy: 20.678,
    r: 20.678,
    transform: "translate(290.071 12.923)",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M319.639.154C306.423,2.2,307.053,7.111,302.821,9.66c-7.455,4.491-10.4,17.461-6.46,26.02,1.052,2.287,3.27,5.406,2.194,8.775a8.77,8.77,0,0,1-3.656,4.387c-3.662,2.261-1.27-.429-2.925,1.462-1.827,2.088,1,5.036-.731,8.775-1.537,3.314-4.707,3.034-5.119,5.118-.709,3.589,7.427,10.8,16.087,10.237,7.71-.505,13.437-7.023,15.356-13.162,1.285-4.112,1.839-11.185-1.462-14.624a18.012,18.012,0,0,1-2.925-3.656c-.947-1.587-2.193-3.676-1.462-5.118.778-1.536,2.983-.728,4.387-2.194,1.9-1.988-.358-5.347,0-8.775.607-5.8,8.831-12.785,17.549-11.7,9.89,1.232,13.518,11.987,13.893,13.162.778,2.436.762,4.793.731,9.506-.044,6.764-.072,11-2.194,15.355-3.051,6.26-6.938,5.583-8.043,10.237-1.724,7.256,6.385,14.542,7.312,15.355,6.876,6.028,17.261,7.84,19.012,5.118,1.578-2.452-5.348-6.267-5.118-13.893.2-6.609,5.547-8.623,4.387-13.162-1.277-5-8.09-3.856-10.968-9.506-2.686-5.273,2.265-8.2,1.462-19.012a33.122,33.122,0,0,0-5.118-15.355c-1.864-2.865-3.759-5.779-7.312-7.312C337.719,3.984,326.63-.928,319.639.154Z",
    transform: "translate(-18.678)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M312.593,18.966c.536,4.528,7.336,6.747,10.237,7.312a16.325,16.325,0,0,0,9.506-.731c1.524-.658,2.08-1.253,3.656-1.462,2.134-.284,3.209.528,6.581,1.462,3.75,1.04,5.625,1.559,6.581.731,1.563-1.354.362-5.783-1.462-8.775-3.374-5.531-9.55-7.244-12.431-8.043-3.291-.913-9.969-2.765-16.087.731-.818.467-7.126,4.174-6.581,8.775Z",
    transform: "translate(-20.407 -0.532)",
    fill: "#2f2e41"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1872",
    "data-name": "Group 1872",
    transform: "translate(436.79 106.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M482.732,144.719c-9.758,4.551-13.637-1.392-13.637-1.392l0-1.771.029-22.784c6.8-4.436,18.266,2.007,18.266,2.007l-4.414,22.659Z",
    transform: "translate(-467.417 -114.332)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M485.772,116.411s-10.089-4.32-15.538-1.066c0,0-5.682,5.759-1.232,7.433l17.517,1.7s3.984-2.671,2.247-4.869a21.035,21.035,0,0,0-2.994-3.2Z",
    transform: "translate(-467.3 -114.131)",
    fill: "#ffebb2"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M101.03,310l8.412,68.234,64.5-.935.795-67.3Z",
    transform: "translate(-6.596 -20.24)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M154.8,292.415a2.121,2.121,0,0,1-1.537-3.677l.145-.578-.057-.138c-1.958-4.667-5.462-.262-10.513.052-7.428.461-7.317,6.079-4.44,12.648.781,1.783-5.85-12.606-5.85-22.265a65.216,65.216,0,0,1,.4-7.275q.335-2.97.93-5.9a68.345,68.345,0,0,1,13.553-28.966A18.188,18.188,0,0,0,155,228.47c.586-1.2,5.617-2.205,5.834-3.515-.368.048-5.961-5.836-5.683-6.181-.513-.779-1.432-1.166-1.992-1.926-2.788-3.779-6.628-3.12-8.633,2.016-4.283,2.162-4.325,5.747-1.7,9.195,1.672,2.194,1.9,5.162,3.369,7.51-.151.193-.308.38-.459.574l-.174.224A4.842,4.842,0,0,1,137.146,235c-.1-.266-.912,14.119-.3-.77s-4.741-7.31-7.452-10.743a5.84,5.84,0,0,0-10.4,2.957q-.008.075-.016.149.6.339,1.177.72A2.877,2.877,0,0,1,119,232.554l-.059.009a28.629,28.629,0,0,0,.755,4.28c-3.459,13.378,4.006,18.252,14.669,18.474l.556.791a70.263,70.263,0,0,0-3.627,17.351l-.009.121a2.716,2.716,0,0,1-4.774,1.568,8.834,8.834,0,0,0-1.193-1.225c-4.623-3.8-11.154-5.2-16.141-8.248a3.3,3.3,0,0,0-5.058,3.213l.02.133a19.328,19.328,0,0,1,2.167,1.044q.6.34,1.178.721a2.876,2.876,0,0,1-1.162,5.235l-.059.009-.121.018.038.091a10.246,10.246,0,0,0,9.908,6.23c5.009-.274,11.232,3.914,16.72,11.32h.006a70.189,70.189,0,0,0,4.715,13.765h16.844c.06-.187.115-.38.169-.568a19.134,19.134,0,0,1-4.661-.278c1.25-1.534,2.5-3.079,3.749-4.612a1.032,1.032,0,0,0,.078-.091c.634-.785,1.274-1.564,1.908-2.348h0a28.032,28.032,0,0,0-.821-7.141Z",
    transform: "translate(-6.795 -14.001)",
    fill: "#60d043"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M544.974,381.745h0a.785.785,0,0,1-.785.785H0v-1.57H544.188A.785.785,0,0,1,544.974,381.745Z",
    transform: "translate(0 -24.873)",
    fill: "#e6e6e6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_2102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2102-2",
    "data-name": "Path 2102",
    d: "M372.907,132.693s-41.443,11.7-37.905,23.4a150.544,150.544,0,0,0,5.723,16.5s-8.035,17.863,16.826,25.906,78.24,13.893,78.24,13.893L467.6,317.324l14.99-4.022L470.42,192.47l-59.49-21.022-8.775-16.818-20.724-22.935-8.524,1Z",
    transform: "translate(-21.86 -8.6)",
    fill: "#e6e6e6"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M307.765,65.026l-.232-2.372-23.9,8.953s-8.775,6.581-11.7,9.506-11.7,8.775-11.7,8.775l7.312-26.324-11.7-5.118s-35.1,46.066-18.28,49.723,46.066-2.925,46.066-2.925l1.462,81.165,61.056,1.828-25.227-84.455L307.765,65.026Z",
    transform: "translate(-15.213 -3.816)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationPending);
export default __webpack_public_path__ + "static/media/application-pending.a8ee51801e3799290ba1e1f5ea5dc286.svg";
export { ForwardRef as ReactComponent };